import { Button, Flex, Image, theme } from "antd";

import StylesContainer from "./style";

import { isLockedByAdminView } from "../../../../../../utils/helper/specialized";

import CloudsOutlined from "../../../../../../image/icon/CloudsOutlined";

const SectionIntroducingAdvice = ({
  handleGetAdviceButtonClick,
  isMobile,
  managerAccess,
}) => {
  const { token } = theme.useToken();

  return (
    <StylesContainer gap={14} vertical>
      <h3
        dangerouslySetInnerHTML={{
          __html: token.proposal_page_dash_want_to_talk_title_content,
        }}
      />
      <Flex align="center" gap={28}>
        <Flex gap={10} vertical>
          <p>{token.goals_page_dash_section_want_talk_copy}</p>
          <p>
            <b
              dangerouslySetInnerHTML={{
                __html: token.proposal_page_dash_want_to_talk_limited_content,
              }}
            />
          </p>
        </Flex>
        <div>
          <Image
            preview={false}
            src={token.proposal_page_dash_want_to_talk_image_link}
            width={130}
          />
        </div>
      </Flex>
      <Button
        disabled={isLockedByAdminView({ managerAccess })}
        icon={<CloudsOutlined />}
        onClick={handleGetAdviceButtonClick}
        shape="round"
        size={isMobile && "large"}
        style={{
          width: isMobile ? "100%" : 150,
          background: token.goals_page_dash_section_want_talk_button_background,
          color: token.goals_page_dash_section_want_talk_button_color,
        }}
        type="text"
      >
        {token.goals_page_dash_section_want_talk_button_copy}
      </Button>
    </StylesContainer>
  );
};

export default SectionIntroducingAdvice;
